import { Tag } from '../../model/tagging/Tag';

import { Factory } from '../../services/Factory';

namespace app.directives.review {

  export interface IReviewStatScope extends angular.IScope {
    value: any;
    numReviewed: number;
    numNotReviewed: number;
  }

  export interface IReviewStatAttributes extends angular.IAttributes {
    name: string;
  }

  export class ReviewStats implements angular.IDirective {
    public restrict: string = 'E';
    public link: (scope: IReviewStatScope, element: angular.IAugmentedJQuery, attrs: IReviewStatAttributes) => void;
    public templateUrl: string;
    public scope = {batch: '=batch'};

    public reviewMetricsService: app.services.metrics.ReviewMetricsService;
    public batch: Tag;

    constructor(reviewMetricsService: app.services.metrics.ReviewMetricsService, $timeout) {

      this.reviewMetricsService = reviewMetricsService;
      this.templateUrl = "partials/review/review_stats.html";

      this.link = (scope: IReviewStatScope, element: angular.IAugmentedJQuery, attrs: IReviewStatAttributes) => {

        scope.$watch("batch", (batch: Tag) => {
          if (batch) {
            this.batch = batch;
            this.ReLoadStatsForBatch(scope);
          }
        });

        scope.$on('tags.complete', () => {
          $timeout(() => {
            this.ReLoadStatsForBatch(scope);
          }, 1000);
        });

        scope.$on('stats.refresh', () => {
          $timeout(() => {
            this.ReLoadStatsForBatch(scope);
          }, 1000);
        });

        scope.$on('reviewmetrics.batch.reviewed', (evt, data) => {
          if (this.batch && this.batch.id == data["batchId"]) {
            scope.numReviewed = data["count"];
          }
        });

        scope.$on('reviewmetrics.batch.notReviewed', (evt, data) => {
          if (this.batch && this.batch.id == data["batchId"]) {
            scope.numNotReviewed = data["count"];
          }
        });

      }
    }

    private ReLoadStatsForBatch(scope: IReviewStatScope) {
      // console.log("Reloading Stats for batch");
      this.ReLoadStats(scope, this.batch.projectId, this.batch.id);
    }

    private ReLoadStats(scope: IReviewStatScope, projectId: string, batchId: string) {
      // console.log("Reloading Stats for projectId: " + projectId + ", batchId: " + batchId);
      this.reviewMetricsService.BroadcastNumReviewedNotReviewed(projectId, batchId);
    }

  }

  frontendApp.directive("iioReviewStats", ["ReviewMetricsService", "$timeout", Factory.Create(ReviewStats)]);
}
